import { useState} from "react";

// ─── SIDEBAR BUTTON ──────────────────────────────────────────
export function SidebarBtn({ icon, active, onClick, tooltip }) {
    const [hovered, setHovered] = useState(false);

    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            title={tooltip}
            style={{
                width: 36,
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                background: active ? "#e8e8ec" : hovered ? "#f0f0f3" : "transparent",
                color: active ? "#1f2937" : "#71717a",
                transition: "all 0.12s",
            }}
        >
            {icon}
        </button>
    );
}